/**
 * inputValidation.js, Cross-validace vstupů proti segmentovým benchmarkům.
 * Vrací pole neblokujících varování pro UI.
 */

/**
 * Validace finančních dat proti benchmarkům segmentu.
 * @param {object} finance - { revenue, cogs, opex, inventory }
 * @param {object} benchmarks - segmentBenchmarks z wizardState
 * @returns {Array<{field: string, message: string, severity: 'info'|'warning'|'high'}>}
 */
export function validateFinanceInputs(finance, benchmarks) {
  if (!benchmarks || !finance) return [];
  const warnings = [];
  const n = v => Number(v) || 0;

  const revenue = n(finance.revenue);
  if (revenue <= 0) return [];

  const cogs = n(finance.cogs);
  const opex = n(finance.opex);
  const ebitda = revenue - cogs - opex;
  const ebitdaMargin = (ebitda / revenue) * 100;
  const grossMargin = ((revenue - cogs) / revenue) * 100;
  const cogsPct = (cogs / revenue) * 100;
  const opexPct = (opex / revenue) * 100;

  // EBITDA marže, sanity (bez prozrazení průměru segmentu)
  if (ebitdaMargin < benchmarks.benchmark_ebitda_margin - 10) {
    warnings.push({
      field: 'ebitda_margin',
      message: `Vaše EBITDA marže (${ebitdaMargin.toFixed(1)} %) vyšla nezvykle nízká. Pokud to nečekáte, zkontrolujte prosím zadané COGS a OPEX, často se omylem prohodí.`,
      severity: 'warning',
    });
  }

  // Hrubá marže, sanity (bez prozrazení průměru segmentu)
  if (grossMargin < benchmarks.benchmark_gross_margin - 15) {
    warnings.push({
      field: 'gross_margin',
      message: `Hrubá marže (${grossMargin.toFixed(1)} %) vyšla nezvykle nízká. Pro jistotu zkontrolujte zadané náklady.`,
      severity: 'warning',
    });
  }

  // OPEX > 50% tržeb, podezřelé
  if (opexPct > 50) {
    warnings.push({
      field: 'opex',
      message: `OPEX tvoří ${opexPct.toFixed(0)} % tržeb, to je neobvykle vysoké. Zkontrolujte, zda COGS a OPEX nejsou prohozené.`,
      severity: 'high',
    });
  }

  // COGS > 85% tržeb
  if (cogsPct > 85) {
    warnings.push({
      field: 'cogs',
      message: `COGS tvoří ${cogsPct.toFixed(0)} % tržeb, ověřte, že nezahrnuje i provozní náklady (ty patří do OPEX).`,
      severity: 'warning',
    });
  }

  return warnings;
}

/**
 * Validace KPI dat proti benchmarkům.
 * @param {object} kpi - { rrs, monthly_ad_spend, ... }
 * @param {number} revenue - roční tržby v Kč
 * @param {object} benchmarks - segmentBenchmarks
 * @returns {Array<{field: string, message: string, severity: string}>}
 */
export function validateKpiInputs(kpi, revenue, benchmarks) {
  // Bez porovnávání KPI s průměrem segmentu, klient nemá vidět, jak si stojí.
  return [];
}
